export default "<ion-backdrop \ntappable=\"false\"\nvisible=\"true\"\n></ion-backdrop>\n<div #paypal></div>";